import { ReloadSidebarButton } from "@/business-settings/common/reload-sidebar-button";
import { SIDEBAR_MODES } from "@/business-settings/constants";
import { useBusinessSettingsSidebar } from "@/business-settings/context/business-settings-sidebar-context";
import { useGetReferralSource } from "@/referral-sources/query";
import { ReferralSource } from "@/referral-sources/referral-source";

export const ReferralSourceReloadButton = ({
  businessId,
  referralSource,
  entityName,
}: {
  businessId: string;
  referralSource: ReferralSource;
  entityName: string;
}) => {
  const { refetch } = useGetReferralSource(businessId, referralSource.id);
  const { updateSidebar } = useBusinessSettingsSidebar();

  const handleClick = async () => {
    const { data: fetchedRecord } = await refetch();

    updateSidebar({
      mode: SIDEBAR_MODES.view,
      selectedItemId: fetchedRecord?.id,
    });
  };

  return <ReloadSidebarButton onClick={handleClick} entityName={entityName} />;
};
